module.exports = __WEBPACK_EXTERNAL_MODULE_103__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"handlebars/dist/handlebars","commonjs2":"handlebars/dist/handlebars","amd":"handlebars","root":"handlebars"}
// module id = 103
// module chunks = 0